var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
      attrs: {
        title: "权限设置",
        "close-on-click-modal": false,
        width: "350px",
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "inputForm",
          staticClass: "auth",
          attrs: { size: "small", model: _vm.inputForm, "status-icon": "" },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.inputFormSubmit()
            },
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-tabs",
            { attrs: { type: "border-card" } },
            [
              _c(
                "el-tab-pane",
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("i", { staticClass: "fa fa-navicon" }),
                    _vm._v(" 菜单权限"),
                  ]),
                  _c(
                    "el-scrollbar",
                    { staticStyle: { height: "450px" } },
                    [
                      _c("el-tree", {
                        ref: "menuListTree",
                        attrs: {
                          data: _vm.menuList,
                          props: {
                            label: "name",
                            children: "children",
                          },
                          "node-key": "id",
                          "default-expanded-keys": ["1"],
                          "default-checked-keys": _vm.menuCheckedKeys,
                          "show-checkbox": "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "数据权限" } },
                [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("i", { staticClass: "fa fa-database" }),
                    _vm._v(" 数据权限"),
                  ]),
                  _c(
                    "el-scrollbar",
                    { staticStyle: { height: "450px" } },
                    [
                      _c("el-tree", {
                        ref: "dataRuleTree",
                        attrs: {
                          data: _vm.dataRuleList,
                          props: {
                            label: "name",
                            children: "children",
                          },
                          "node-key": "id",
                          "default-expanded-keys": ["1"],
                          "default-checked-keys": _vm.dataRuleCheckedKeys,
                          "show-checkbox": "",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              directives: [{ name: "noMoreClick", rawName: "v-noMoreClick" }],
              attrs: {
                type: "primary",
                icon: "el-icon-check",
                size: "small",
                plain: "",
              },
              on: {
                click: function ($event) {
                  return _vm.inputFormSubmit()
                },
              },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }